<div class="recherche-discogs">
  <form class="search-form">
    <mat-form-field class="search-full-width">
      <mat-label>Recherche cover Discogs</mat-label>
      <input #searchInput matInput placeholder="Recherche cover Discogs" value="" (keydown.enter)="discogsSearchCoverEnter($event, searchInput.value)" >
      <button mat-button *ngIf="searchInput.value" matSuffix aria-label="Clear" (click)="searchInput.value=''">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </mat-form-field>
  </form>
  <button color="primary" class="search-full-width-button" mat-flat-button (click)="discogsSearchCover(searchInput.value)">Recherche</button>
</div>

<div class="searchResults">
  <mat-progress-spinner *ngIf="loading" class="mat-progress-spinner-coverSearch" mode="indeterminate"></mat-progress-spinner>

  <div style="text-align: center">
    <img *ngFor="let discogsResult of filteredDiscogsResults" [src]="discogsResult.thumb"
         style="margin: 10px; cursor: pointer"
         (click)="selectCover(discogsResult.cover_image, discogsResult.year, discogsResult.title)"
         matTooltip="{{ discogsResult.year }} | {{ discogsResult.title }} ({{ discogsResult.cover_image | urlCoverSizeFormat}})" matTooltipPosition="above" />
  </div>

  <mat-paginator [length]="discogsResults.length" [pageSize]="defaultRecords" [pageSizeOptions]="[5, 10, 20]" (page)="pageEvent = $event; onPaginateChange($event)">
  </mat-paginator>
</div>
